import { get_token } from "@/router";

const TABS = Object.freeze([
  { key: "preview", label: "Preview Form" },
  { key: "questions", label: "Questions" },
  { key: "sections", label: "Sections" },
  { key: "forms", label: "Forms" },
  { key: "assignments", label: "Profile Assignments" },
]);

const STEPS = Object.freeze([
  { number: 1, title: "Create questions", description: "Add the questions and answer types that your form will use.", tab: "questions", status: "Next" },
  { number: 2, title: "Create sections", description: "Group related questions into reusable sections.", tab: "sections", status: "Pending" },
  { number: 3, title: "Create a form", description: "Create the form and assign your prepared sections to it.", tab: "forms", status: "Pending" },
  { number: 4, title: "Preview and publish", description: "Review the user-facing form before publishing.", tab: "preview", status: "Pending" },
  { number: 5, title: "Assign form", description: "Assign the published form to profiles.", tab: "assignments", status: "Pending" },
]);

export const getHeaders = () => ({ Authorization: `Token ${get_token()}` });
export const getJsonHeaders = () => ({ ...getHeaders(), "Content-Type": "application/json" });

export const createDynamicFormsState = () => ({
    active_tab: "questions",
    show_create_panel: false,
    loading: false,
    questions: [], sections: [], forms: [],
    selected_preview_form_id: "", preview_sections: [], preview_loading: false,
    preview_profile_mode: "personal",
    question_types: [], profile_types: [],
    profile_assignment_form: null,
    selected_profile_ids: [], initial_profile_ids: [], saving_profile_assignment: false,
    question_form: { text: "", number: "", type: "", mandatory: false, locked: false, options: [] },
    section_form: { name: "", locked: false },
    dynamic_form: { name: "", description: "" },
    selected_question_ids: [], selected_section_ids: [],
    assignment_target: null, assignment_type: "", assignment_section_id: "",
    editing_id: null,
    validation_errors: {},
    tabs: TABS,
    steps: STEPS,
});
